export default __webpack_public_path__ + "static/media/isb-icon.6ab5ef47.webp";